import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { NsPanel } from 'components/common/ns-panel/NsPanel';

export const testId = 'submitEmailSuccessTestId';

export const SubmitEmailSuccess = () => {
  return (
    <NsPanel testId={testId}>
      <NsAlert state="success" heading="Thank you, you are on the list!">
        <p>
          We&apos;ve got your email address, and we hope to be able to send you
          a notification for great value soon.
        </p>
      </NsAlert>
    </NsPanel>
  );
};

export default SubmitEmailSuccess;
